import { Show } from "solid-js";

import { scaicontrolReference } from "~/lib/api";

type Props = {
  error: unknown;
};

/**
 * Renders ScaiControl's `code` + `request_id` from a failed CRM API
 * call as a copy-able "Reference" line. Empty render when the error
 * didn't originate at ScaiControl.
 *
 * Reps quote these at support; ScaiControl indexes both server-side,
 * so a single copy/paste resolves the request without back-and-forth.
 */
export function ScaiControlErrorReference(props: Props) {
  const ref = () => scaicontrolReference(props.error);
  return (
    <Show when={ref()}>
      <p class="text-xs opacity-70 mt-1">
        <span class="opacity-60">Reference:</span>{" "}
        <Show when={ref()!.code}>
          <code>{ref()!.code}</code>
        </Show>
        <Show when={ref()!.code && ref()!.request_id}>
          <span class="opacity-60"> · </span>
        </Show>
        <Show when={ref()!.request_id}>
          <code>{ref()!.request_id}</code>
        </Show>
      </p>
    </Show>
  );
}
